export const TRANSLATIONS = {
    EN: {
        ADMIN_SETTINGS: {
            NOTARIES: 'Notaries',
            ACCOUNTS: 'Accounts',
            ADD_ACCOUNT: 'Add account',
            ADD_RISK_WORD: 'Add risk word',
            ADD_DOCUMENT_TAG: 'Add document tag',
            RISK_WORD_UPDATED: 'Risk word updated',
            DOCUMENT_TAGS: 'Document Tags',
            MANDATORY_PRODUCTS: 'Mandatory products',
            PRODUCT_TYPES: 'Product types',
            ADD_PRODUCT: 'Add product',
            ADD_JOB_CATEGORY: 'Add job category',
            INVOICES: 'Invoices',
            JOBS: 'Jobs',
            JOB_CATEGORIES: 'Job categories',
            REGIONS: 'Regions',
            NOTARY: 'Notaries',
            BOOKKEEPER: 'Bookkeepers',
            LEGAL_TASK_TYPES: 'Legal task types',
            FEEDBACK: 'Feedback',
            EMAILS: 'Emails',
            PRODUCTS: 'Products',
            PACKAGES: 'Packages',
            PAYMENT_METHODS: 'Payment methods',
            SERVICE_PROVIDERS: 'Service Providers',
            USERS: 'Users',
            TENANTS: 'Tenants',
            ADD_REGION: 'Add Region',
            ADD_NOTARY: 'Add Notary',
            ADD_BOOKKEEPER: 'Add Bookkeeper',
            SERVICE_PROVIDER_ADDED: 'Service provider successfully added',
            SERVICE_PROVIDER_UPDATED: 'Service provider successfully updated',
            SERVICE_PROVIDER_DELETED: 'Service provider successfully deleted',
            USER_ADDED: 'User successfully added',
            USER_UPDATED: 'User successfully updated',
            USER_DELETED: 'User successfully deleted',
            ACCOUNT_ADDED: 'Account successfully added',
            ACCOUNT_NOT_ADDED: 'Failed to add the account',
            ACCOUNT_UPDATED: 'Account successfully updated',
            ACCOUNT_UPDATE_FAILED: 'Failed to update the account',
            ACCOUNT_DELETED: 'Account successfully deleted',
            ADD_CONTRACT_TEMPLATE: 'Add contract template',
            CONTRACT_TEMPLATES: 'Contract templates',
            CONTRACT_TEMPLATE: 'Contract template',
            CONTRACT_TEMPLATE_ADDED: 'Contract template added',
            CONTRACT_TEMPLATE_UPDATED: 'Contract template updated',
            CONTRACT_TEMPLATE_DELETED: 'Contract template deleted',
            SEARCH_NOTARY: 'Notary search...',
            ACTIVE: 'Active',
            RISK_WORDS: 'Risk words',
            VERBAL_CONSENTS: 'Verbal consents',
            ADD_VERBAL_CONSENT: 'Record verbal consent',
            BANK_PROVIDER: 'Bank provider',
            NOTE: 'Note',
            REVOKE: 'Revoke',
            REVOKE_VERBAL_CONSENT: 'Revoke verbal consent',
            REVOKE_VERBAL_CONSENT_CONFIRM: 'Revoke the verbal consent for {email}?',
            VERBAL_CONSENT_ADDED: 'Verbal consent recorded',
            VERBAL_CONSENT_REVOKED: 'Verbal consent revoked',
            VERBAL_CONSENT_ALREADY_EXISTS: 'A pending verbal consent already exists for this email and provider',
            VERBAL_CONSENT_ADD_FAILED: 'Could not record verbal consent',
            VERBAL_CONSENT_STATUS: {
                PENDING: 'Pending',
                APPLIED: 'Applied',
                REVOKED: 'Revoked',
            },
            WORD: 'Woord',
            REGEXP: 'Regular expression',
            MATCH_WHOLE_WORD: 'Match whole word',
            RISK_LEVEL: 'Risk level',
            COUNTRIES: 'Countries',
            LICENSES: 'Account Licenses',
            LICENSE_TYPES: 'Licenses',
            ADD_LICENSE_TYPE: 'Add license',
            LICENSE_TYPE_ADDED: 'License added',
            LICENSE_TYPE_UPDATED: 'License updated',
            LICENSE_TYPE_DELETED: 'License deleted',
            ADD_LICENSE_TO_ACCOUNT: 'Add license to account',
            LICENSE_ADDED_TO_ACCOUNT: 'License added to account',
            LICENSE_REMOVED_FROM_ACCOUNT: 'License removed from account',
            ADD_LEGAL_TASK_TYPE: 'Add legal task type',
            LEGAL_TASK_TYPE_ADDED: 'Legal task type added',
            LEGAL_TASK_TYPE_UPDATED: 'Legal task type updated',
            LEGAL_TASK_TYPE_DELETED: 'Legal task type deleted',

            OPTIONS: {
                ENGLISH: 'EN',
                INBRENG: 'Inbreng',
                LIVING_ABROAD: 'Living abroad',
                INTERNATIONAL_IDENTIFICATION: 'International identification',
                FAST_URGENCY: 'Fast urgency',
                HIGH_URGENCY: 'High urgency',
                DUTCH: 'NL',
                BV_CATEGORY_1_2: '1-2 bv category',
                BV_CATEGORY_3_5: '3-5 bv category',
                BV_CATEGORY_6: '6 bv category',
                B2C: 'Business to consumer',
                SHORT_RESIDENCE: 'Lives < 2 years in NL',
                DEVIATING_SHARE_DISTRIBUTION: 'Deviating share distribution',
                DEVIATING_INCORPORATION_ADDRESS: 'Deviating incorporation address',
                TEST_MODE: 'Test Mode',
            },
            PLEASE_SELECT_ONE_NOTARY: 'Please select at least one notary for each option. Missing {option}',
            PURCHASE_TYPE: 'In which process type is this product available?',
            AUTO_START_INTERVIEW: 'Automatically schedule an appointment via calendly',
            COMMISSION: 'Commission',
            SECTORS: 'Sectors',
            ADD_SECTOR: 'Add sector',
            SECTOR_UPDATED: 'Sector updated',
            SECTOR_DELETED: 'Sector deleted',
            SECTOR_ADDED: 'Sector added',
            ALLOWED: 'Allowed',
            ALLOWED_URGENCY: 'Allowed urgency',
        },
    },
    NL: {
        ADMIN_SETTINGS: {
            NOTARIES: 'Notarissen',
            ACCOUNTS: 'Accounts',
            ADD_ACCOUNT: 'Account toevoegen',
            ADD_DOCUMENT_TAG: 'Voeg document tag toe',
            ADD_RISK_WORD: 'Risico woord toevoegen',
            RISK_WORD_UPDATED: 'Risico woord bijgewerkt',
            DOCUMENT_TAGS: 'Documenten tags',
            MANDATORY_PRODUCTS: 'Verplichte producten',
            PRODUCT_TYPES: 'Type producten',
            ADD_PRODUCT: 'Product toevoegen',
            ADD_JOB_CATEGORY: 'Voeg categorie toe',
            INVOICES: 'Facturen',
            JOBS: 'Jobs',
            JOB_CATEGORIES: 'Job categorieën',
            REGIONS: 'Regio',
            NOTARY: 'Notarissen',
            BOOKKEEPER: 'Boekhouder',
            LEGAL_TASK_TYPES: 'Juridische taaktypen',
            FEEDBACK: 'Feedback',
            EMAILS: 'Emails',
            PRODUCTS: 'Producten',
            PACKAGES: 'Packages',
            PAYMENT_METHODS: 'Betaalmethodes',
            SERVICE_PROVIDERS: 'Service Providers',
            USERS: 'Gebruikers',
            TENANTS: 'Tenants',
            ADD_REGION: 'Regio toevoegen',
            ADD_NOTARY: 'Notaris toevoegen',
            ADD_BOOKKEEPER: 'Bookkeeper toevoegen',
            SERVICE_PROVIDER_ADDED: 'Serviceprovider succesvol toegevoegd',
            SERVICE_PROVIDER_UPDATED: 'Serviceprovider succesvol bijgewerkt',
            SERVICE_PROVIDER_DELETED: 'Serviceprovider succesvol verwijderd',
            USER_ADDED: 'Gebruiker succesvol toegevoegd',
            USER_UPDATED: 'Gebruiker succesvol bijgewerkt',
            USER_DELETED: 'Gebruiker succesvol verwijderd',
            ACCOUNT_ADDED: 'Account succesvol toegevoegd',
            ACCOUNT_NOT_ADDED: 'Mislukt om het account toe te voegen',
            ACCOUNT_UPDATED: 'Account succesvol bijgewerkt',
            ACCOUNT_UPDATE_FAILED: 'Mislukt om het account bij te werken',
            ACCOUNT_DELETED: 'Account succesvol verwijderd',
            ADD_CONTRACT_TEMPLATE: 'Voeg contract sjabloon toe',
            CONTRACT_TEMPLATES: 'Contract sjablonen',
            CONTRACT_TEMPLATE: 'Contract sjabloon',
            CONTRACT_TEMPLATE_ADDED: 'Contract sjabloon toegevoegd',
            CONTRACT_TEMPLATE_UPDATED: 'Contract sjabloon bijgewerkt',
            CONTRACT_TEMPLATE_DELETED: 'Contract sjabloon verwijderd',
            SEARCH_NOTARY: 'Notaris zoeken...',
            ACTIVE: 'Actief',
            RISK_WORDS: 'Risico woorden',
            VERBAL_CONSENTS: 'Mondelinge toezeggingen',
            ADD_VERBAL_CONSENT: 'Mondelinge toezegging vastleggen',
            BANK_PROVIDER: 'Bank',
            NOTE: 'Notitie',
            REVOKE: 'Intrekken',
            REVOKE_VERBAL_CONSENT: 'Mondelinge toezegging intrekken',
            REVOKE_VERBAL_CONSENT_CONFIRM: 'Mondelinge toezegging voor {email} intrekken?',
            VERBAL_CONSENT_ADDED: 'Mondelinge toezegging vastgelegd',
            VERBAL_CONSENT_REVOKED: 'Mondelinge toezegging ingetrokken',
            VERBAL_CONSENT_ALREADY_EXISTS: 'Er bestaat al een openstaande mondelinge toezegging voor dit e-mailadres en deze bank',
            VERBAL_CONSENT_ADD_FAILED: 'Mondelinge toezegging kon niet worden vastgelegd',
            VERBAL_CONSENT_STATUS: {
                PENDING: 'Openstaand',
                APPLIED: 'Toegepast',
                REVOKED: 'Ingetrokken',
            },
            REGEXP: 'Reguliere express',
            WORD: 'Woord',
            MATCH_WHOLE_WORD: 'Match hele woord',
            RISK_LEVEL: 'Risico niveau',
            COUNTRIES: 'Landen',
            LICENSES: 'Account Licenties',
            LICENSE_TYPES: 'Licenties',
            ADD_LICENSE_TYPE: 'Licentie toevoegen',
            LICENSE_TYPE_ADDED: 'Licentie toegevoegd',
            LICENSE_TYPE_UPDATED: 'Licentie bijgewerkt',
            LICENSE_TYPE_DELETED: 'Licentie verwijderd',
            ADD_LICENSE_TO_ACCOUNT: 'Licentie toevoegen aan account',
            LICENSE_ADDED_TO_ACCOUNT: 'Licentie toegevoegd aan account',
            LICENSE_REMOVED_FROM_ACCOUNT: 'Licentie verwijderd van account',
            ADD_LEGAL_TASK_TYPE: 'Voeg juridische taaktype toe',
            LEGAL_TASK_TYPE_ADDED: 'Juridische taaktype toegevoegd',
            LEGAL_TASK_TYPE_UPDATED: 'Juridische taaktype bijgewerkt',
            LEGAL_TASK_TYPE_DELETED: 'Juridische taaktype verwijderd',
            OPTIONS: {
                ENGLISH: 'EN',
                INBRENG: 'Inbreng',
                LIVING_ABROAD: 'Living abroad',
                INTERNATIONAL_IDENTIFICATION: 'International identification',
                FAST_URGENCY: 'Fast urgency',
                HIGH_URGENCY: 'High urgency',
                DUTCH: 'NL',
                BV_CATEGORY_1_2: '1-2 bv categorie',
                BV_CATEGORY_3_5: '3-5 bv categorie',
                BV_CATEGORY_6: '6 bv categorie',
                B2C: 'Consument',
                SHORT_RESIDENCE: 'Woont < 2 jaar in NL',
                DEVIATING_SHARE_DISTRIBUTION: 'Afwijkende aandelenverdeling',
                DEVIATING_INCORPORATION_ADDRESS: 'Afwijkend vestigingsadres',
                TEST_MODE: 'Testmodus',
            },
            PLEASE_SELECT_ONE_NOTARY: 'Selecteer voor elke optie minstens één notaris. Missend {option}',
            PURCHASE_TYPE: 'In welke proces type is dit product beschikbaar?',
            AUTO_START_INTERVIEW: 'Automatisch een afspraak plannen via calendly',
            COMMISSION: 'Commissie',
            SECTORS: 'Sectoren',
            ADD_SECTOR: 'Sector toevoegen',
            SECTOR_UPDATED: 'Sector bijgewerkt',
            SECTOR_DELETED: 'Sector verwijderd',
            SECTOR_ADDED: 'Sector toegevoegd',
            ALLOWED: 'Toegestaan',
            ALLOWED_URGENCY: 'Urgentie toegestaan',
        },
    },
};
